// GENERATED FILE — DO NOT EDIT.
//
// Source of truth: packages/python-shared/nu_assist_shared/extensions.json
// Regenerate:      pnpm gen:extension-registry
//
// Edits here are silently lost on the next regeneration, and
// extensions.generated.test.ts fails the moment this file disagrees with the
// JSON — so a hand-edit shows up as a red test rather than as a wrong Store
// link months later.

/** One Chrome extension build this repo produces. */
export interface ExtensionBuild {
  readonly id: string;
  readonly product: string;
  /** CWS listing slug, or `null` for a build that is never published. */
  readonly slug: string | null;
  readonly listingName: string | null;
  readonly firstPublish: string | null;
  /** Whether the API accepts this origin for auth. */
  readonly trusted: boolean;
}

export const EXTENSIONS: Readonly<Record<string, ExtensionBuild>> = {
  "local": {
    id: "hbphdkmoejdhgkdadndolaepfppjlmbg",
    product: "nucce",
    slug: null,
    listingName: null,
    firstPublish: null,
    trusted: true,
  },
  "dev": {
    id: "bllhiaingmkdhnimajbhfibblfghcekf",
    product: "nucce",
    slug: "nu-assist-dev",
    listingName: "nu-assist (dev)",
    firstPublish: "2026-06-10",
    trusted: true,
  },
  "prod": {
    id: "abbaebjlkpidifjhgefkklheoanbhkko",
    product: "nucce",
    slug: "nu-assist",
    listingName: "nu-assist",
    firstPublish: "2026-06-15",
    trusted: true,
  },
  "legacy-team-shared": {
    id: "lofjnlgijmipkolccaaakicbkppofpdb",
    product: "nucce",
    slug: null,
    listingName: null,
    firstPublish: null,
    trusted: true,
  },
  "baby-chops-local": {
    id: "mikcpdpbnlkdlpceffkhkdbelepiiamb",
    product: "baby-chops",
    slug: null,
    listingName: null,
    firstPublish: null,
    trusted: true,
  },
  "baby-chops-dev": {
    id: "ghbgaodbaiphegjecnpgfjmfnjcmbcea",
    product: "baby-chops",
    slug: "baby-chops-dev",
    listingName: "ChopLink (Dev)",
    firstPublish: "2026-07-02",
    trusted: true,
  },
  "baby-chops-prod": {
    id: "dgjpbjaolkcjpimdonjnnjknngifmjmi",
    product: "baby-chops",
    slug: "baby-chops",
    listingName: "ChopLink",
    firstPublish: "2026-07-09",
    trusted: true,
  },
  "chopbook-local": {
    id: "hjeogkecfdknlinjnbgofkldjoljhfbn",
    product: "chopbook",
    slug: null,
    listingName: null,
    firstPublish: null,
    trusted: true,
  },
  "chopbook-dev": {
    id: "ndiggljnhpblbbdafbohenadmojpmjcl",
    product: "chopbook",
    slug: "chopbook-tool-dev",
    listingName: "ChopBook (Dev)",
    firstPublish: "2026-08-10",
    trusted: true,
  },
  "chopbook-prod": {
    id: "ajnkgbeciackpoclnknejfeoodbjppfl",
    product: "chopbook",
    slug: "chopbook-tool",
    listingName: "ChopBook",
    firstPublish: "2026-08-18",
    trusted: true,
  },
} as const;

/** `chrome-extension://<id>` for a declared stage. */
export function extensionOrigin(stage: keyof typeof EXTENSIONS): string {
  return `chrome-extension://${EXTENSIONS[stage].id}`;
}

/**
 * The Web Store listing URL for a stage, or `null` when that build is never
 * published — callers MUST handle the null branch rather than rendering a
 * broken link.
 */
export function cwsListingUrl(stage: keyof typeof EXTENSIONS): string | null {
  const build = EXTENSIONS[stage];
  if (!build || build.slug === null) return null;
  return `https://chromewebstore.google.com/detail/${build.slug}/${build.id}`;
}
